import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {EngineScriptService} from "@tj/tj-dmp-lib-api";
import {DropdownModule} from "primeng/dropdown";
import {TranslateModule} from "@ngx-translate/core";
import {NgIf} from "@angular/common";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dmp-select-groovy-script',
    templateUrl: './select-groovy-script.component.html',
    styleUrls: ['./select-groovy-script.component.scss'],
    imports: [
        DropdownModule,
        FormsModule,
        TranslateModule,
        NgIf
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectGroovyScriptComponent
        }
    ]
})
export class SelectGroovyScriptComponent implements OnInit, OnChanges, ControlValueAccessor {

    @Input() disabled = false;
    @Input() value: SelectItem;
    @Input() tenant: string;
    @Input() type: 'IMPORTS' | 'EXPORTS';
    @Output() changeScript = new EventEmitter<SelectItem>();

    @Input() onlyInput = true;

    list: SelectItem[] = [];
    touched = false;

    constructor(private engineScriptService: EngineScriptService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.update();
    }

    ngOnInit(): void {
        this.update();
    }

    private update(): void {
        if (this.tenant && this.type) {
            this.engineScriptService.getListScriptsByTenant(this.tenant, this.type).subscribe(list => {
                this.list = list.map(lg =>
                    ({label: lg, value: lg} as SelectItem)
                );
                this.writeValue(this.list[0]);
                this.onChange(this.value);
            });
        }
    }

    onChange: any = () => { /**/
    };
    onTouched: any = () => { /**/
    };

    writeValue(item: any): void {
        this.value = item;
    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    langueChange() {
        this.changeScript.emit(this.value);
        this.onChange(this.value);
        this.onTouched(this.value);
    }
}
